import React from 'react';
import { connect } from 'react-redux';
import { getShopsAtAddress, setAddress } from '../actions';
import UserLocator from '../containers/UserLocatorContainer';
import { TranslatedInput } from './Text';
import { getDict } from '../utilities/dict';

class SearchInputContainer extends React.Component {
  constructor(props) {
    super(props);

    this.placesDetailsLAT = null;
    this.placesDetailsLNG = null;

    this.state = {
      useAutocomplete: true
    };
  }

  onChangeHandler() {
    const { dispatch, config } = this.props;
    const placesOptions = {
      componentRestrictions: {
        country: config.country
      },
      fields: ['name', 'geometry.location', 'place_id', 'formatted_address']
    };

    // ADD AUTOCOMPLETE
    // NOTE: In order to get autocomplete with the *third* character, we have to
    // initialize it after the the second has been typed. Autocomplete only
    // triggers when a key has been pressed - hence with the third it has to be
    // in place already.
    const charCount = 1;

    //! false - disables autocomplete "PlaceService Google API call"
    if (false && this.input.value.length >= charCount && !this.autocomplete) {

      /*
      Start of
      "don't make PlaceService Google API call for the second time if input doesn't change"
       - reset if input changes
       - it will be re-defined if user selects autocomplete ("PlaceService Google API call")
       - if input changes and autocomplete isn't used, it will stay null and trigger PlaceService Google API call
      */
      this.placesDetailsLAT = null;
      this.placesDetailsLNG = null;
      //End-of

      this.autocomplete = new google.maps.places.Autocomplete(this.input, placesOptions); //Google API call to return autocomplete data
      this.autocompleteListener = google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
        // get lat/lng via autocomplete (via PlaceService Google API call) when user selects the address from autocomplete menu
        const autocompletePlacesDetails = this.autocomplete.getPlace();

        // store lat/lng of the address from autocomplete "PlaceService Google API call"
        if (autocompletePlacesDetails.geometry.location) {
          this.placesDetailsLAT = autocompletePlacesDetails.geometry.location.lat();
          this.placesDetailsLNG = autocompletePlacesDetails.geometry.location.lng();
        }
        this.handlePlaceChanged.bind(this);
      });
    }

    // REMOVE AUTOCOMPLETE
    //! false - disables autocomplete "PlaceService Google API call"
    else if (false && this.input.value.length < charCount && this.autocomplete) {
      const pacContainer = document.querySelector('.pac-container')

      google.maps.event.removeListener(this.autocompleteListener);
      google.maps.event.clearInstanceListeners(this.autocomplete);
      google.maps.event.clearInstanceListeners(this.input);
      this.autocomplete = false;
      this.autocompletListener = undefined;

      if (pacContainer) {
        pacContainer.parentNode.removeChild(pacContainer);
      }
    }
    dispatch(setAddress(this.input.value, false, this.placesDetailsLAT, this.placesDetailsLNG))
  }

  handlePlaceChanged() {
    this.props.dispatch(setAddress(this.input.value, false, this.placesDetailsLAT, this.placesDetailsLNG));
    google.maps.event.clearInstanceListeners(this.input);

  }

  render() {
    const { search, dispatch, config } = this.props;
    const { country } = config;

    const inputComponent = (
      <TranslatedInput
        id="selenium-test-search-input"
        type="text"
        value={search.address}
        placeholderId='search.input-placeholder'
        className="form-control"
        setRef={n => this.input = n}
        onChange={this.onChangeHandler.bind(this)}
      />
    );

    const dict = getDict(config.language);

    return (
      <div className="search-input mb-1 mb-md-0">
        <form onSubmit={e => {
          e.preventDefault();
          dispatch(getShopsAtAddress(this.input.value, country, this.placesDetailsLAT, this.placesDetailsLNG));
          window.wts.push(['send', 'click', { linkId: 'PaketShop Suchen' }]);
        }}>

          <div className="input-group">
            <UserLocator ariaLabel={dict('search.icon-locate.aria-label')} />

            <div className="input-group search-input__input">
              {inputComponent}
            </div>

            <div className="input-group-addon-btn">
              <button
                id="selenium-test-search-button"
                className="btn btn-secondary"
                aria-label={dict('search.icon-search.aria-label')}
                type="submit"
              >
                <span aria-hidden="true" className="halflings halflings-search"></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ search, config }) => ({
  search, config
});

export default connect(mapStateToProps)(SearchInputContainer);
